// Available platforms for geocoder
export const AVAILABLE_PLATFORMS = [
  "Review Platforms",
  "Forums",
  "Twitter",
  "Instagram",
  "Linkedin",
  "TikTok",
  "Facebook",
  "China"
];
